import { FormField } from "@ab.uitools/ui-library/components/FormField";
import { Input } from "@ab.uitools/ui-library/components/Input";
import { useFormProps } from "@ab.uitools/ui-library/hooks/useFormProps";
import type { TFormData } from "@ab.uitools/ui-library/types/globalTypes";
import { type Dispatch, type SetStateAction, useEffect } from "react";
import type { UseFormSetError } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface Props {
  onInit?: (setError: UseFormSetError<TFormData>) => void;
  defaultValue?: string;
  isRename?: boolean;
  setHasChanges?: Dispatch<SetStateAction<boolean>>;
}

export const TemplateNameForm = ({
  onInit,
  defaultValue,
  isRename,
  setHasChanges,
}: Props) => {
  const { t } = useTranslation();
  const { reset, setError, watch } = useFormProps();

  const name = watch?.("templateName");

  useEffect(() => {
    reset?.({ templateName: defaultValue ?? "" });
  }, [defaultValue]);

  useEffect(() => {
    if (setError) onInit?.(setError);
  }, [setError]);

  useEffect(() => {
    if (isRename) {
      setHasChanges?.(name !== defaultValue);
    }
  }, [name]);

  return (
    <FormField
      name="templateName"
      errorMessageIcon="infoFilled"
      As={(props) => (
        <Input
          {...props}
          required
          label={t("template.templateNameModal.templateName")}
          placeholder={t("template.templateNameModal.enterTemplateName")}
          maxCount={50}
          maxLength={50}
        />
      )}
    />
  );
};
